/**
 * Google Analytics – only runs in production.
 * Loaded from index.html so it does not touch main app code.
 */
if (import.meta.env.PROD) {
  const id = import.meta.env.VITE_GOOGLE_ANALYTICS_TRACKING_ID;
  if (id) {
    const dataLayer: unknown[][] = [];
    window.dataLayer = dataLayer;
    function gtag(...args: unknown[]) {
      dataLayer.push(args);
    }
    gtag('js', new Date());
    gtag('config', id);
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(script);
  }
}
